import TableCell from '@mui/material/TableCell';

export default TableCell;
